/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_View_RecordInputs */

const en_directory_detail_view_record = /** @type {(inputs: Directory_Detail_View_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View record`)
};

const zh_directory_detail_view_record = /** @type {(inputs: Directory_Detail_View_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看档案`)
};

/**
* | output |
* | --- |
* | "View record" |
*
* @param {Directory_Detail_View_RecordInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_view_record = /** @type {((inputs?: Directory_Detail_View_RecordInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_View_RecordInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_view_record(inputs)
	return zh_directory_detail_view_record(inputs)
});
export { directory_detail_view_record as "directory.detail.view_record" }